import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class DateFormatService {

  constructor(
    private datePipe: DatePipe
  ) { }
  public getDateFrom(date, format: string = 'yyyy-MM-dd') {
    return this.datePipe.transform(
      date,
      format
    );
  }

}
